import React from 'react'
import { Bag } from '@components/icons'
import { useCartItemsCount } from '@components/alfakher/pylot-cart-manager/src/hooks/use-cart-items-count'
import { useTranslation } from 'react-i18next'
import { useUI } from '@corratech/pylot-ui/context'
import { useCart } from '@corratech/pylot-cart-manager'
import { Button } from '@corratech/pylot-ui'
import s from './../UserNav/UserNav.module.scss'

export const AddToCartIcon = (): JSX.Element | null => {
    const { t } = useTranslation()
    const { data: cartData } = useCart()
    const { toggleSidebar } = useUI()
    const cartItemsCount = useCartItemsCount(cartData?.data?.cart?.items)
    return (
        <div className={s.bagIcon}>
            <Button
                className={s.bagButton}
                variant="link"
                onClick={toggleSidebar}
                aria-label={t('Bag')}
            >
                <Bag />
                {cartItemsCount && cartItemsCount > 0 ? (
                    <span className={s.cartItemCount}>{cartItemsCount}</span>
                ) : (
                    ''
                )}
            </Button>
        </div>
    )
}
export default AddToCartIcon
